var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '../base-management-service';
var OpportunityService = /** @class */ (function (_super) {
    __extends(OpportunityService, _super);
    function OpportunityService() {
        return _super.call(this, '/api/v1/opportunity') || this;
    }
    OpportunityService.prototype.getOpportunityLoads = function (site, date, statuses, materialGroup, dispatchDesks, carriers, carrierGroups, market, platt) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getopportunityloads';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                Site: site,
                                Date: date,
                                Statuses: statuses,
                                MaterialGroup: materialGroup,
                                DispatchDesks: dispatchDesks,
                                Carriers: carriers,
                                CarrierGroups: carrierGroups,
                                Market: market === 'ALL' ? null : market,
                                Platt: platt,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get opportunity loads');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Unable to get opportunity loads');
                        console.error(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityService.prototype.getOpportunityLoad = function (loadId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getopportunityload';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { LoadId: loadId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get opportunity load');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Unable to get opportunity load');
                        console.error(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityService.prototype.open = function (loadid) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/open';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                LoadId: loadid,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Unable to open opportunity');
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityService.prototype.accept = function (loadid) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/accept';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                LoadId: loadid,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error('Unable to accept opportunity');
                        console.error(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityService.prototype.deny = function (loadid) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/deny';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                LoadId: loadid,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error('Unable to deny opportunity');
                        console.error(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityService.prototype.getDefault = function () {
        return {
            siteId: '',
            siteName: '',
            loadId: '',
            voyageId: '',
            newLoad: '',
            materialId: '',
            materialName: '',
            materialType: '',
            materialGroup: '',
            dispatchDeskId: '',
            dispatchDeskName: '',
            carrierId: '',
            carrierName: '',
            carrierGroupId: '',
            carrierGroupName: '',
            timeWindowStart: '',
            timeWindowEnd: '',
            sourceType: '',
            vendorId: '',
            vendorName: '',
            loadStatus: '',
            loadOpportunityStatus: '',
            actionsAvailable: [],
            modId: '',
            modDate: '',
            timeout: '',
            rslId: '',
            locoId: '',
            locoIdPrimary: '',
            marketId: '',
            plattsRegion: '',
        };
    };
    OpportunityService.prototype.getValidationRules = function () {
        return {
            id: {
                required: true,
                max: 6,
                numeric: true,
            },
            name: {
                required: true,
                max: 30,
            },
            vendorId: {
                required: true,
                max: 4,
                alpha_num: true,
            },
            vendorName: {
                required: true,
                max: 30,
            },
            vendorType: {
                required: true,
            },
            vendorSubType: {
                required: true,
            },
            priceExpirationTime: {
                required: true,
            },
            unitOfMeasure: {
                required: true,
            },
            vendorBillTime: {
                required: true,
            },
            carrierLoadNumber: {
                max: 50,
            },
            carrierLoadInstructions: {
                max: 500,
            },
            timeZoneAbbreviation: {
                required: true,
            },
            notes: {
                max: 500,
            },
            tcnId: {
                required: true,
                max: 15,
            },
            tcnName: {
                required: true,
                max: 60, // todo update requirements
            },
            aliasName: {
                max: 30,
            },
            tcnAddress: {
                street: {
                    required: true,
                    max: 30,
                },
                city: {
                    required: true,
                    max: 30,
                },
                state: {
                    required: true,
                    max: 2,
                },
                zip: {
                    required: true,
                    max: 10,
                },
            },
        };
    };
    OpportunityService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], OpportunityService);
    return OpportunityService;
}(BaseManagementService));
export { OpportunityService };
